export default {
      id: "distance-no-interline-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#distance-no-interline",
      toString: function () {
        return this.url;
      }
    }